module.exports = __webpack_public_path__ + "img/dr.0b7593de.png";